import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type SubmitGiftVoucherTtbPaymentMutation,
    type SubmitGiftVoucherTtbPaymentMutationVariables,
    SubmitGiftVoucherTtbPaymentDocument,
} from '../../../../../api/mutations/submitGiftVoucherTtbPayment';
import { type AgreementValues } from '../../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';

// calls ttb submit payment api
// this calls the manage transactions of porsche
export const submitPayment = async (agreements: AgreementValues, token: string, promoCodeId?: string) => {
    const response = await fetch('/api/ttb/submitGiftVoucherPayment', {
        method: 'POST',
        body: JSON.stringify({
            token,
            agreedConsents: Object.entries(agreements)
                .filter(Boolean)
                .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null)),
            promoCodeId,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error();
    }

    return response.json();
};

// ttb deposit submission calls the application journey
const useGiftVoucherTtbDepositSubmission = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: AgreementValues, skipDeposit: boolean) => {
            const { data } = await apolloClient.mutate<
                SubmitGiftVoucherTtbPaymentMutation,
                SubmitGiftVoucherTtbPaymentMutationVariables
            >({
                mutation: SubmitGiftVoucherTtbPaymentDocument,
                variables: {
                    token,
                    agreedConsents: Object.entries(values)
                        .filter(Boolean)
                        .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null))
                        .filter(Boolean),
                    skipDeposit,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useGiftVoucherTtbDepositSubmission;
